import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import { formatTeamsData } from "./ChartBuilder/teamFilterComponents";
import { props } from "bluebird";

// const teamFilterHierarchy = ({
//   label,
//   value,
//   onChange,
//   name,
//   options,
//   disabled,
//   labelColorCondition,
//   renderValue,
//   getOptionLabel,
//   getOptionValue,
//   data,
//   onTeamChange,
// }) => {
//   const teamsList = formatTeamsData(data);
//   // const handleChange = (e) => {
//   //   const selectedvalues = e.target.value;
//   //   let teamRawData = data;

//   //   console.log("created_funnel_teamRawData", teamRawData);

//   //   console.log("selectedvalues", selectedvalues);

//   //   // const relationships = extractParentChildRelationshipsWithIds(data);

//   //   // let filteredValues = filterSelectedValues(selectedvalues, relationships);

//   //   onTeamChange(selectedvalues);
//   // };

//   const handleChange = (e) => {
//     // Get the selected values from the event (multi-select dropdown)
//     let selectedValues = [...e.target.value]; // Copy selected values into an array
//     console.log("step1:selectedValues", selectedValues);

//     let lastSelected = selectedValues[selectedValues.length - 1]; // Get the most recently selected value
//     console.log("step2:lastSelected", lastSelected);

//     let teamRawData = data; // Assume `data` contains hierarchical team structure
//     console.log("step3:teamRawData", teamRawData);

//     const updatedSelectedValues = new Set(selectedValues); // Use Set to store unique selected values
//     console.log("step4:updatedSelectedValues");

//     // Function to remove all child elements when a parent is selected
//     const deselectChildren = (parent, teams) => {
//       teams.forEach((team) => {
//         if (team.Parent === parent) {
//           // If the current team is a child of the selected parent, remove it
//           team.teams.forEach((child) => {
//             updatedSelectedValues.delete(child.Parent); // Remove child from selection
//             deselectChildren(child.Parent, teams); // Recursively remove all deeper children
//           });
//         } else if (team.teams.length > 0) {
//           // If the current team has sub-teams, check them as well
//           deselectChildren(parent, team.teams);
//         }
//       });
//     };

//     // Function to remove all parent elements when a child is selected
//     const deselectParents = (child, teams) => {
//       for (const team of teams) {
//         // Check if the current team has this child in its sub-teams
//         if (team.teams.some((subTeam) => subTeam.Parent === child)) {
//           updatedSelectedValues.delete(team.Parent); // Remove parent from selection
//           deselectParents(team.Parent, teamRawData); // Recursively remove all higher-level parents
//         }
//         // Continue checking deeper levels
//         deselectParents(child, team.teams);
//       }
//     };

//     if (lastSelected) {
//       // If a parent is selected, remove all its children to prevent conflicts
//       console.log("step5:lastSelected_deselectChildren", lastSelected);

//       deselectChildren(lastSelected, teamRawData);

//       console.log("step6:lastSelected_deselectParents", lastSelected);

//       // If a child is selected, remove all its parent elements up to the root
//       deselectParents(lastSelected, teamRawData);
//     }

//     // Convert the Set back to an array and pass the updated selection to the parent component
//     console.log("Updated Selected Values:", Array.from(updatedSelectedValues));
//     onTeamChange(Array.from(updatedSelectedValues));
//   };

//   return (
//     <FormControl fullWidth disabled={disabled}>
//       <InputLabel
//         style={{
//           color: labelColorCondition ? "#4472c4" : "#000",
//         }}
//         id={`${name}-label`}
//       >
//         {label}
//       </InputLabel>
//       <Select
//         value={value}
//         onChange={handleChange}
//         name={name}
//         multiple
//         renderValue={renderValue}
//       >
//         {teamsList.map((option) => {
//           return (
//             <MenuItem
//               key={getOptionValue(option)}
//               value={option.label}
//               style={{
//                 marginLeft: `${option.indent * 1}rem`,
//               }}
//             >
//               {`${getOptionLabel(option)}`}
//             </MenuItem>
//           );
//         })}
//       </Select>
//     </FormControl>
//   );
// };

// export default teamFilterHierarchy;

const TeamFilterHierarchy = ({
  label,
  value,
  variant,
  onChange,
  name,
  options,
  disabled,
  labelColorCondition,
  renderValue,
  getOptionLabel,
  getOptionValue,
  data,
  onTeamChange,
}) => {
  const teamsList = formatTeamsData(data);
  // const handleChange = (e) => {
  //   const selectedvalues = e.target.value;
  //   let teamRawData = data;

  //   console.log("created_funnel_teamRawData", teamRawData);

  //   console.log("selectedvalues", selectedvalues);

  //   // const relationships = extractParentChildRelationshipsWithIds(data);

  //   // let filteredValues = filterSelectedValues(selectedvalues, relationships);

  //   onTeamChange(selectedvalues);
  // };

  const handleChange = (e) => {
    // Get the selected values from the event (multi-select dropdown)
    let selectedValues = [...e.target.value]; // Copy selected values into an array
    console.log("step1:selectedValues", selectedValues);

    let lastSelected = selectedValues[selectedValues.length - 1]; // Get the most recently selected value
    console.log("step2:lastSelected", lastSelected);

    let teamRawData = data; // Assume `data` contains hierarchical team structure
    console.log("step3:teamRawData", teamRawData);

    const updatedSelectedValues = new Set(selectedValues); // Use Set to store unique selected values
    console.log("step4:updatedSelectedValues");

    // Function to remove all child elements when a parent is selected
    const deselectChildren = (parent, teams) => {
      teams.forEach((team) => {
        if (team.Parent === parent) {
          // If the current team is a child of the selected parent, remove it
          team.teams.forEach((child) => {
            updatedSelectedValues.delete(child.Parent); // Remove child from selection
            deselectChildren(child.Parent, teams); // Recursively remove all deeper children
          });
        } else if (team.teams.length > 0) {
          // If the current team has sub-teams, check them as well
          deselectChildren(parent, team.teams);
        }
      });
    };

    // Function to remove all parent elements when a child is selected
    const deselectParents = (child, teams) => {
      for (const team of teams) {
        // Check if the current team has this child in its sub-teams
        if (team.teams.some((subTeam) => subTeam.Parent === child)) {
          updatedSelectedValues.delete(team.Parent); // Remove parent from selection
          deselectParents(team.Parent, teamRawData); // Recursively remove all higher-level parents
        }
        // Continue checking deeper levels
        deselectParents(child, team.teams);
      }
    };

    if (lastSelected) {
      // If a parent is selected, remove all its children to prevent conflicts
      console.log("step5:lastSelected_deselectChildren", lastSelected);

      deselectChildren(lastSelected, teamRawData);

      console.log("step6:lastSelected_deselectParents", lastSelected);

      // If a child is selected, remove all its parent elements up to the root
      deselectParents(lastSelected, teamRawData);
    }

    // Convert the Set back to an array and pass the updated selection to the parent component
    console.log("Updated Selected Values:", Array.from(updatedSelectedValues));
    onTeamChange(Array.from(updatedSelectedValues));
  };

  return (
    <FormControl fullWidth disabled={disabled}>
      {variant === undefined && <InputLabel
        style={{
          color: labelColorCondition ? "#4472c4" : "#000",
        }}
        id={`${name}-label`}
      >
        {label}
      </InputLabel>}
      <Select variant={variant}
      id="filter_team_filter"
        value={value}
        onChange={handleChange}
        name={name}
        multiple
        
        renderValue={renderValue}
        data-test="Team"
      >
        {teamsList.map((option) => {
          return (
            <MenuItem
              key={getOptionValue(option)}
              value={option.label}
              style={{
                marginLeft: `${option.indent * 1}rem`,
              }}
            >
              {`${getOptionLabel(option)}`}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

export default TeamFilterHierarchy;
